import PropTypes from "prop-types";

const NavDropdown = ({ children, isOpen, position }) => {
  if (!isOpen) return null;

  const { top, left } = position;
  return (
    <div
      className="fixed z-50 bg-white shadow-lg border border-[#666666]"
      style={{
        top: top + window.scrollY, // 8px offset below the link
        left,
        minWidth: "170px",
      }}>
      <div className="pt-4 pl-4 pr-4">{children}</div>
    </div>
  );
};

NavDropdown.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  position: PropTypes.shape({
    top: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
    width: PropTypes.number,
  }).isRequired,
};

export default NavDropdown;
